<template>
  <v-card class="event-summary" :to="route">
    <v-container class="info-container ma-0 pa-0 full-height">
      <v-layout column justify-space-between ma-0 class="full-height">
        <v-layout row ma-0 mb-3 class="justify-space-between no-wrap">
          <span class="H4 primary-text text--darken-1 one-line pr-2">{{ title }}</span>
          <v-chip label v-if="category" class="category light-background primary--text text--lighten-1 flex-none">{{ category }}</v-chip>
        </v-layout>
        <v-layout row ma-0 class="justify-space-between align-end">
          <v-layout column class="info-container">
            <v-layout row class="flex-none ma-0" v-if="location">
              <v-icon small class="material-symbols-rounded" color="primary lighten-1">pin_drop</v-icon>
              <span class="label one-line">{{ location }}</span>
            </v-layout>          
            <v-layout row class="flex-none ma-0" v-if="requiresReservation">
              <v-icon small class="material-symbols-rounded" color="primary lighten-1">calendar_add_on</v-icon>
              <span class="label one-line">{{ $t('upcoming_events.requires_reservation') }}</span>
            </v-layout>
          </v-layout>
          <v-layout row class="flex-none ma-0">
            <v-icon small class="material-symbols-rounded" color="primary lighten-1">schedule</v-icon>
            <span class="label one-line opening-hours">{{ start }} - {{ end }}</span>
          </v-layout>
        </v-layout>
      </v-layout>

    </v-container>
  </v-card>
</template>
<script>
import moment from 'moment'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { getTimeFormat } from '@/lib/helpers/HoursFormatter'
import routeNames from '@/router/routes'
import { reservationTypes } from '@/config'
export default {
  props: {
    event: Object,
  },
  computed: {
    route () {
      return this.event.pageId ? { name: routeNames.page_details.name, params: { pageId: this.event.pageId }} : null
    },
    title () {
      return getTextValue(this.event.title)
    },
    location () {
      return this.event.location ? getTextValue(this.event.location.name) : null
    },
    start () {
      return moment.utc(this.event.start).format(getTimeFormat())
    },
    end () {
      return moment.utc(this.event.end).format(getTimeFormat())
    },
    category () {
      return this.event.activityCategory && this.event.activityCategory.name ? this.event.activityCategory.name : null
    },
    requiresReservation () {
      return this.event.reservationMethods && !!this.event.reservationMethods.find((method) => {
        return method.type === reservationTypes.IN_VENUE
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.category.v-chip {
  border-radius: 5px !important; 
  max-height: 24px;
  padding: 0 10px;
  text-align: center;
  font-family: 'Mukta Mahee';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 133.333% */
  letter-spacing: 0.25px;
}
.info-container {
  gap: 10px;
}
.event-summary {
  padding: 20px;
  min-width: 142px;
  border-radius: 10px;
  border: 1px solid var(--v-custom-grey-lighten1);
  background: #FFF;
  box-shadow: 0px 0px 17.86666px 0px rgba(0, 0, 0, 0.10) !important;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  .one-line {
    max-width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-icon {
    margin-right: 5px;
    line-height: 20px;
  }
  span.label {
    color: var(--v-grey-2-base);
    font-family: 'Mukta Mahee';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 166.667% */
    letter-spacing: 0.25px;
  }
  span.opening-hours {
    color: var(--v-primary-darken-1);
    text-align: right;
    font-family: 'Mukta';
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
}
</style>